<template>
	<v-row>
		<div class="text-center grey--text text--darken-2 text-h5 font-weight-300 w-100">
			Step {{ activeStep }} of {{ countStep }}
		</div>
		<v-col cols="12">
			<p>To begin the registration process, fill in the fields below.</p>

			<p>Before you start, please prepare scans of your company register documents to
				enclose in the application form.</p>

			<p>Note: if your company is located in the European Union, please make sure that
				the
				document has an active VAT EU number at it.</p>
		</v-col>

		<v-col>
			<v-form ref="form" lazy-validation>
				<v-row>
					<v-col cols="12">
						<v-select :label="question1" outlined required :items="options1" hide-details="auto" dense
							:rules="required" v-model="question1Answear" />

						<v-select class="mt-4" :label="question2" outlined required :items="options2"
							hide-details="auto" :rules="required" v-model="question2Answear" multiple
							v-on:input="limiter" />
					</v-col>

					<v-col cols="12" xs="12" class="d-flex align-center">
						<v-spacer />
						<div class="grey--text text--darken-2 font-weight-500 mr-2">
							Step {{ activeStep }} of {{ countStep }}
						</div>
						<v-btn large color="primary" @click="next()" class="ma-1">
							NEXT STEP
						</v-btn>
					</v-col>
				</v-row>
			</v-form>
		</v-col>
	</v-row>
</template>
<script>
import { validationRules } from '@/helpers/validationRules'

export default {
	name: 'BlockRegisterInfo',
	components: {},
	computed: {
		activeStep() {
			return this.$store.getters['REGISTER_STORE/STEP'];
		},
		countStep() {
			return this.$store.getters['REGISTER_STORE/STEP_COUNT'];
		},
		surveyAnswer1() {
			return this.$store.getters['REGISTER_STORE/SURVEY_1'];
		},
		surveyAnswer2() {
			return this.$store.getters['REGISTER_STORE/SURVEY_2'];
		},
		uuid() {
			return this.$store.getters['REGISTER_STORE/SURVEY_UUID'];
		},
	},
	data: () => ({
		...validationRules(),

		question1: 'Where did you hear about WOOKAH?',
		options1: [
			'Shisha bar / lounge',
			'Instagram / Facebook',
			'Internet search',
			'Trade fair',
			'Influencer / review',
			'Shop / distributor',
			'AI recommendation',
			'Other',
		],
		question1Answear: null,

		question2: 'Why did you choose WOOKAH? (Choose up to 3 answers)',
		options2: [
			'Design',
			'Product quality',
			'Smoking experience',
			'Natural wood finish',
			'Brand reputation',
			'Recommendation from a business partner',
			'Customer requests',
			'Modularity options',
			'Other'
		],
		question2Answear: null,
	}),
	methods: {
		limiter(e) {
			if (e.length > 3) {
				e.pop()
			}
		},

		next() {
			if (!this.$refs.form.validate()) {
				return;
			}

			this.$gtag.event(
				'Custom',
				{
					'klik': 'register-step-2',
				}
			);

			this.$store.dispatch('REGISTER_STORE/storeStepOne', {
				form: {
					source: this.question1Answear,
					why_wookah: this.question2Answear,
					uuid: this.uuid,
				},
			})
				.then((resp) => {
					if (resp.data.success) {
						this.$store.commit('REGISTER_STORE/STEP_SET', this.activeStep + 1);

						this.$store.commit('REGISTER_STORE/DATA_SET', {
							name: 'surveyAnswer1',
							value: this._.cloneDeep(this.question1Answear),
						})
						this.$store.commit('REGISTER_STORE/DATA_SET', {
							name: 'surveyAnswer2',
							value: this._.cloneDeep(this.question2Answear),
						})
						this.$store.commit('REGISTER_STORE/DATA_SET', {
							name: 'surveyUuid',
							value: resp.data.uuid,
						})
					}
					this.loading = false
				})
				.catch(err => {
					console.error(err)
					this.loading = false
				});
		},
	},
	watch: {},
	created() {
		if (this.surveyAnswer1) {
			this.question1Answear = this._.cloneDeep(this.surveyAnswer1);
		}
		if (this.surveyAnswer2) {
			this.question2Answear = this._.cloneDeep(this.surveyAnswer2);
		}
	}
}
</script>
